(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('EmployeePhoneSearch', EmployeePhoneSearch);

    EmployeePhoneSearch.$inject = ['$resource'];

    function EmployeePhoneSearch($resource) {
        var resourceUrl =  'api/_search/employee-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
